class HHVariantPicker extends HTMLElement {
  constructor() {
    super()

    this.dynamicSections = Array.from(document.querySelectorAll('[data-section-rerender]')).map(el => el.dataset.sectionId)
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.updateVariantStatuses()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.renderDynamicSections()
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        const value = Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value
        fieldset.querySelectorAll('.js-vp-input-value').forEach(el => el.innerHTML = value)

        return value
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      )
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })

    this.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      composed: true,
      detail: {
        variant: this.currentVariant
      },
    }))
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return

    window.dispatchEvent(new CustomEvent('slide:change', {
      bubbles: true,
      composed: true,
      detail: {
        id: `${this.dataset.section}-${this.currentVariant.featured_media.id}`
      }
    }))
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateVariantStatuses () {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll('.vp__input')];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value')
      const availableElement = availableValuesList.includes(value)

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement)
      }
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML
        // Update variant SKU
        if (document.querySelector('.js-variant-sku') && html.querySelector('.js-variant-sku')) {
          document.querySelector('.js-variant-sku').innerHTML = html.querySelector('.js-variant-sku').innerHTML
        }

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
  }

  renderDynamicSections () {
    if (this.dynamicSections.length === 0) return

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&sections=${this.dynamicSections}`
    )
      .then((response) => response.json())
      .then((response) => {
        this.dynamicSections.forEach(sectionId => {
          // Update dynamic PDP sections by variant
          const html = new DOMParser().parseFromString(response[sectionId], 'text/html')
          const updatedNodes = html.querySelectorAll('[data-rerender]')

          document
            .querySelector(`[id^="shopify-section-"][id*="${sectionId}"]`)
            .querySelectorAll('[data-rerender]')
            .forEach((node, index) => {
              node.replaceWith(updatedNodes[index])
            })
        })
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    
    const customizerButton = document
    .getElementById(`product-form-${this.dataset.section}`)
    ?.querySelector('.js-personalize-button')

    if (!!addButton) {
      if (disable) {
        addButton.setAttribute('disabled', true)
        if (text) addButton.textContent = text
      } else {
        addButton.removeAttribute('disabled')
        addButton.textContent = window.variantStrings.addToCart
      }
    }

    if (!!customizerButton) {
      if (disable) {
        customizerButton.setAttribute('disabled', true)
        if (text) customizerButton.textContent = text
      } else {
        customizerButton.removeAttribute('disabled')
        customizerButton.textContent = window.variantStrings.personalize
      }
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"][variants-data]').textContent)
    return this.variantData
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)
